'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reactReduxForm = require('react-redux-form');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _logo = require('common/components/logo');

var _logo2 = _interopRequireDefault(_logo);

var _logInForm = require('./log-in-form');

var _logInForm2 = _interopRequireDefault(_logInForm);

require('./log-in-page.scss');

var _hello = require('common/images/hello.svg');

var _hello2 = _interopRequireDefault(_hello);

var _g2_crowd_smallbiz_ = require('common/images/g2_crowd_smallbiz_2016.png');

var _g2_crowd_smallbiz_2 = _interopRequireDefault(_g2_crowd_smallbiz_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Top-level component for standalone Log In page.
 * Expects some props from the backend, such as CSRF token.
 */
var LogInPage = function (_React$Component) {
    _inherits(LogInPage, _React$Component);

    function LogInPage(props) {
        _classCallCheck(this, LogInPage);

        var _this = _possibleConstructorReturn(this, (LogInPage.__proto__ || Object.getPrototypeOf(LogInPage)).call(this, props));

        var initialState = {
            emailAddress: _this.props.emailAddress,
            password: '',
            csrfToken: _this.props.csrfToken,
            rememberMe: false,
            pendingTsmGroupGuid: _this.props.pendingTsmGroupGuid,
            redirectUrl: _this.props.redirectUrl
        };

        _this.store = (0, _redux.createStore)((0, _reactReduxForm.combineForms)({
            logIn: initialState
        }), (0, _redux.applyMiddleware)(_reduxThunk2['default']));
        return _this;
    }

    _createClass(LogInPage, [{
        key: 'render',
        value: function render() {
            var externalHomepageUrl = _hfReactHelper2['default'].urlHelper('', _hfReactHelper2['default'].HfSites.SITE_CODE_HS, 'www');
            return _react2['default'].createElement(
                _reactRedux.Provider,
                { store: this.store },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-log-in' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'row l-padding-b-30 l-padding-t-40' },
                        _react2['default'].createElement(
                            'div',
                            { className: 'small-12 columns' },
                            _react2['default'].createElement(_logo2['default'], { siteCode: 'S', isLink: true, href: externalHomepageUrl })
                        )
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'row m-log-in--greeting l-margin-v-35' },
                        _react2['default'].createElement(
                            'div',
                            { className: 'columns push-6 medium-6 text-centered m-log-in--right' },
                            _react2['default'].createElement('img', { className: 'l-img-centered', src: _hello2['default'] })
                        )
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'row' },
                        _react2['default'].createElement(
                            'div',
                            { className: 'columns medium-6 m-log-in--left' },
                            _react2['default'].createElement(
                                'div',
                                null,
                                _react2['default'].createElement(
                                    'p',
                                    { className: 'l-margin-v-20' },
                                    'HelloSign Ranked #1 eSignature Solution for Small Business in G2 Crowd'
                                ),
                                _react2['default'].createElement('img', { className: 'l-margin-v-20', src: _g2_crowd_smallbiz_2['default'] })
                            )
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'columns medium-6 small-12 m-log-in--right' },
                            _react2['default'].createElement(_logInForm2['default'], this.props),
                            _react2['default'].createElement('hr', { className: 'l-margin-t-40 l-margin-b-15' }),
                            _react2['default'].createElement(
                                'div',
                                { className: 'l-text-centered c-ashen m-log-in--sign-up-copy' },
                                'Don\'t have an account?\xA0',
                                _react2['default'].createElement(
                                    'a',
                                    { className: 'm-log-in--sign-up-link', href: '/account/signUp' },
                                    'Sign up now \u203A'
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return LogInPage;
}(_react2['default'].Component);

LogInPage.propTypes = {
    // CSRF Token - Sent from the server
    csrfToken: _react2['default'].PropTypes.string.isRequired,

    // Email value - This is useful to provide for testing purposes
    emailAddress: _react2['default'].PropTypes.string,

    // Needed by the LogInCaptcha component
    recaptchaPublicKey: _react2['default'].PropTypes.string.isRequired,

    // Needed by the GoogleLoginOrSignup component
    googleOpenIdUrl: _react2['default'].PropTypes.string.isRequired,

    redirectUrl: _react2['default'].PropTypes.string,
    pendingTsmGroupGuid: _react2['default'].PropTypes.string
};


module.exports = LogInPage;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/log-in-page.jsx
 ** module id = 1016
 ** module chunks = 0
 **/